<template>
        <div>
            <div :class="{ 'u-loader' : templates === null }">
                <ul class="c-list mb-4">
                    <li v-for="( template, idx ) in templates"
                        class="c-list__item c-list__item--add">
                        <div class="d-block d-md-flex justify-content-between text-center text-md-left">
                            <div v-text="template.title"></div>

                            <div class="text-center text-md-right">
                                <button class="btn btn-yokumiru-blue btn-sm mr-1"
                                        @click="modalEdit( idx )">編集
                                </button>

                                <button class="btn btn-danger btn-sm"
                                        @click="modalDelete( idx )">削除
                                </button>
                            </div>
                        </div>
                    </li>
                </ul>

                <button @click="modalAdd"
                        class="btn btn-yokumiru-orange btn-settings">
                    テンプレートを追加
                </button>
            </div>

            <div v-if="template !== null">
                <!--  追加・編集モーダル  -->
                <b-modal v-model="modalShow"
                         :title="template.id ? 'テンプレートを編集' : 'テンプレートを追加'"
                         :ok-only="true"
                         @ok="handleOk"
                         :ok-title="template.id ? '編集' : '追加'"
                         ok-variant="yokumiru-orange">

                    <form @submit.stop.prevent="postTemplate">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group m-form__group">
                                        <label>タイトル</label>

                                        <input v-model="template.title"
                                               class="form-control m-input m-input--air"
                                               :class="{ 'is-invalid' : errors.title }">

                                        <div v-if="errors.title"
                                             v-text="errors.title[0]"
                                             class="invalid-feedback d-block">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group m-form__group">
                                        <label>テンプレート本文</label>

                                        <textarea v-model="template.body"
                                                  rows="10"
                                                  class="form-control m-input m-input--air"
                                                  :class="{ 'is-invalid' : errors.body }">
                                        </textarea>

                                        <div v-if="errors.body"
                                             v-text="errors.body[0]"
                                             class="invalid-feedback d-block">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </b-modal>

                <!--  削除モーダル  -->
                <b-modal v-model="modalDeleteShow"
                         title=""
                         @ok="handleDelete"
                         ok-title="削除"
                         ok-variant="danger"
                         cancel-title="キャンセル"
                         cancel-variant="yokumiru-gray">

                    <form @submit.stop.prevent="deleteTemplate">
                        <p class="text-center">下記のテンプレートを削除してもよろしいですか？</p>

                        <div class="modal-body">
                            <h6>タイトル：</h6>
                            <p>{{ template.title }}</p>

                            <hr>

                            <h6>テンプレート本文：</h6>
                            <textarea :value="template.body"
                                      class="form-control m-input m-input--air"
                                      style="width: 100%;"
                                      rows="10"
                                      disabled>
                            </textarea>
                        </div>
                    </form>
                </b-modal>
            </div>
        </div>
</template>

<script>
    import constants from '../../constants';

    export default  {
        props: {
            doctor: {
                type: Object,
                default: null,
            }
        },

        data: function() {
            return {
                modalShow: false,
                modalDeleteShow: false,
                templates: null,
                template: null,
                errors: [],
            };
        },

        created: function() {
            this.initTemplate();
            this.fetchTemplates();
        },

        methods: {
            /**
             * テンプレートオブジェクトの初期化
             */
            initTemplate: function() {
                this.template = {
                    doctor_id: this.doctor.id,
                    title: null,
                    body: null,
                };
            },

            /**
             * テンプレート一覧取得
             */
            fetchTemplates: function() {
                this.templates = null;

                axios.get( constants.doctor.medical_record_templates.endpoint.base )
                    .then( ({data}) => {
                        this.templates = data;
                    } );
            },

            /**
             * 追加ボタン押下時
             */
            modalAdd: function() {
                this.initTemplate();
                this.modalShow = true;
            },

            /**
             * 編集ボタン押下時
             */
            modalEdit: function( idx ) {
                this.template = _.clone( this.templates[ idx ] );
                this.modalShow = true;
            },

            /**
             * 削除ボタン押下時
             */
            modalDelete: function( idx ) {
                this.template = this.templates[ idx ];
                this.modalDeleteShow = true;
            },

            /**
             * モーダルウィンドウ
             * 登録クリック時
             */
            handleOk: function( evt ) {
                evt.preventDefault();
                this.postTemplate();
            },

            /**
             * モーダルウィンドウ
             * 削除クリック時
             */
            handleDelete: function( evt ) {
                evt.preventDefault();
                this.deleteTemplate();
            },

            /**
             * テンプレート登録・更新
             */
            postTemplate: function() {
                const params = _.clone( this.template );

                if ( this.template.id ) {
                    this.updateTemplate( params );
                }
                else {
                    this.storeTemplate( params );
                }
            },

            /**
             * テンプレート登録
             */
            storeTemplate: function( params ) {
                axios.post( `${constants.doctor.medical_record_templates.endpoint.base}`, params )
                    .then( ({data}) => {
                        bus.$emit( 'alert-success', 'テンプレートを登録しました。' );
                        this.errors = [];

                        this.templates.push( data );
                        this.initTemplate();

                        this.modalShow = false;
                    } )
                    .catch( ({response}) => {
                        bus.$emit( 'alert-danger' );

                        if ( response.data.errors ) {
                            this.errors = response.data.errors;
                        }
                    } );
            },

            /**
             * テンプレート更新
             */
            updateTemplate: function( params ) {
                axios.put( `${constants.doctor.medical_record_templates.endpoint.base}/${this.template.id}`, params )
                    .then( ({data}) => {
                        bus.$emit( 'alert-success', 'テンプレートを更新しました。' );
                        this.errors = [];

                        const idx = this.templates.findIndex( template => {
                            return Number( template.id ) === Number( data.id )
                        } );

                        this.templates[ idx ] = data;
                        this.initTemplate();

                        this.modalShow = false;
                    } )
                    .catch( ({response}) => {
                        bus.$emit( 'alert-danger' );

                        if ( response.data.errors ) {
                            this.errors = response.data.errors;
                        }
                    } );
            },

            /**
             * テンプレート削除
             */
            deleteTemplate: function() {
                const id = this.template.id;

                axios.delete( `${constants.doctor.medical_record_templates.endpoint.base}/${id}` )
                    .then( () => {
                        bus.$emit( 'alert-success', 'テンプレートを削除しました。' );
                        this.errors = [];

                        const idx = this.templates.findIndex( template => {
                            return Number( template.id ) === Number( id )
                        } );

                        this.templates.splice( idx, 1 );
                        this.initTemplate();

                        this.modalDeleteShow = false;
                    } )
                    .catch( ({response}) => {
                        bus.$emit( 'alert-danger' );

                        if ( response.data.errors ) {
                            this.errors = response.data.errors;
                        }
                    } );
            },
        },
    }
</script>

<style scoped lang="scss">
    .btn-settings {
        width: 100%;
        max-width: 200px;
        display: block;
        margin: 0 auto;
    }
</style>
